import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  orders: {
    list: [],
    perPage: 10,
    total: 0,
    loading: false,
  },
  return: {
    list: [],
    perPage: 10,
    total: 0,
    loading: false,
    dashboard: {},
  },
  payments: {
    list: [],
    perPage: 10,
    total: 0,
    loading: false,
  },
  paymentsHistory: {
    list: [],
    perPage: 10,
    total: 0,
    loading: false,
  },
  importHistory: {
    list: [],
    perPage: 10,
    total: 0,
    loading: false,
  },
  dashboard: {
    data: null,
    loading: false,
  },
  importLoading: false,
  selectedOrder: null,
};

// Import Orders API
export const importMeeshoOrders = createAsyncThunk(
  "meesho/import-orders",
  async (formData, { dispatch }) => {
    try {
      const response = await axios.post("meesho/order/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const importMeeshoOrdersReturn = createAsyncThunk(
  "meesho/import-orders-return",
  async (formData, { dispatch }) => {
    try {
      const response = await axios.post(
        "meesho/order/return/import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const importMeeshoOrdersPayment = createAsyncThunk(
  "meesho/import-orders-payment",
  async (formData, { dispatch }) => {
    try {
      const response = await axios.post(
        "meesho/order/payment/import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const meeshoOrderReturnClaimStatus = createAsyncThunk(
  "meesho/order/return/claim-status",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("meesho/order/return/claim-status", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get Orders List API
export const getMeeshoOrdersList = createAsyncThunk(
  "meesho/get-orders-list",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("meesho/order/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get return Orders List API
export const getMeeshoReturnList = createAsyncThunk(
  "meesho/get-orders -return-list",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("meesho/order/return/list", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getMeeshoReturnById = createAsyncThunk(
  "meesho/get-orders -return-by-id",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("meesho/order", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);
export const importMeeshoReturnRTOAction = createAsyncThunk(
  "meesho/order/return/verify",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("meesho/order/return/verify", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get payment Orders List API
export const getMeeshoPaymentList = createAsyncThunk(
  "meesho/get-orders -payment-list",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("meesho/order/payment/list", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get Single Order API
export const getMeeshoOrder = createAsyncThunk(
  "meesho/get-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`meesho-order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get Payment Import History List API
export const getMeeshoPaymentImportHistory = createAsyncThunk(
  "meesho/get-payment-import-history",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("meesho/order/payment/history", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get Single Import History API
export const getMeeshoPaymentImportHistoryDetail = createAsyncThunk(
  "meesho/get-payment-import-history-detail",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`meesho/order/payment/history/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get Import History List API
export const getMeeshoImportHistory = createAsyncThunk(
  "meesho/get-import-history",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("meesho/order/history", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get Single Import History API
export const getMeeshoImportHistoryDetail = createAsyncThunk(
  "meesho/get-import-history-detail",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`meesho/order/history/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

// Get Dashboard Data API
export const getMeeshoDashboard = createAsyncThunk(
  "meesho/get-dashboard",
  async (params = {}, { dispatch }) => {
    try {
      const response = await axios.get("meesho/order/dashboard", { params });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const meeshoSlice = createSlice({
  name: "meesho",
  initialState,
  reducers: {
    clearSelectedOrder: (state) => {
      state.selectedOrder = null;
    },
    setSelectedOrder: (state, action) => {
      state.selectedOrder = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Import Orders
      .addCase(importMeeshoOrders.pending, (state) => {
        state.importLoading = true;
      })
      .addCase(importMeeshoOrders.fulfilled, (state, action) => {
        state.importLoading = false;
      })
      .addCase(importMeeshoOrders.rejected, (state, action) => {
        state.importLoading = false;
      })

      // Orders List
      .addCase(getMeeshoOrdersList.pending, (state) => {
        state.orders.loading = true;
      })
      .addCase(getMeeshoOrdersList.fulfilled, (state, action) => {
        state.orders.loading = false;
        state.orders.list = action?.payload?.data?.data?.orders ?? [];
        state.orders.perPage = action?.payload?.data?.data?.perPage ?? 10;
        state.orders.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getMeeshoOrdersList.rejected, (state, action) => {
        state.orders.loading = false;
        state.orders.list = [];
        state.orders.perPage = 10;
        state.orders.total = 0;
      })

      // return List
      .addCase(getMeeshoReturnList.pending, (state) => {
        state.return.loading = true;
      })
      .addCase(getMeeshoReturnList.fulfilled, (state, action) => {
        state.return.loading = false;
        state.return.list = action?.payload?.data?.data?.returns ?? [];
        state.return.perPage = action?.payload?.data?.data?.perPage ?? 10;
        state.return.total = action?.payload?.data?.data?.total ?? 0;
        state.return.dashboard =
          action?.payload?.data?.data?.dashboardData ?? null;
      })
      .addCase(getMeeshoReturnList.rejected, (state, action) => {
        state.return.loading = false;
        state.return.list = [];
        state.return.perPage = 10;
        state.return.total = 0;
      })

      // payment List
      .addCase(getMeeshoPaymentList.pending, (state) => {
        state.payments.loading = true;
      })
      .addCase(getMeeshoPaymentList.fulfilled, (state, action) => {
        state.payments.loading = false;
        state.payments.list = action?.payload?.data?.data?.payments ?? [];
        state.payments.perPage = action?.payload?.data?.data?.perPage ?? 10;
        state.payments.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getMeeshoPaymentList.rejected, (state, action) => {
        state.payments.loading = false;
        state.payments.list = [];
        state.payments.perPage = 10;
        state.payments.total = 0;
      })

      // payment List
      .addCase(getMeeshoPaymentImportHistory.pending, (state) => {
        state.paymentsHistory.loading = true;
      })
      .addCase(getMeeshoPaymentImportHistory.fulfilled, (state, action) => {
        state.paymentsHistory.loading = false;
        state.paymentsHistory.list =
          action?.payload?.data?.data?.importHistory ?? [];
        state.paymentsHistory.perPage =
          action?.payload?.data?.data?.perPage ?? 10;
        state.paymentsHistory.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getMeeshoPaymentImportHistory.rejected, (state, action) => {
        state.paymentsHistory.loading = false;
        state.paymentsHistory.list = [];
        state.paymentsHistory.perPage = 10;
        state.paymentsHistory.total = 0;
      })

      // Single Order
      .addCase(getMeeshoOrder.fulfilled, (state, action) => {
        state.selectedOrder = action?.payload?.data?.data?.order ?? null;
      })
      .addCase(getMeeshoOrder.rejected, (state, action) => {
        state.selectedOrder = null;
      })

      // Import History List
      .addCase(getMeeshoImportHistory.pending, (state) => {
        state.importHistory.loading = true;
      })
      .addCase(getMeeshoImportHistory.fulfilled, (state, action) => {
        state.importHistory.loading = false;
        state.importHistory.list =
          action?.payload?.data?.data?.importHistories ?? [];
        state.importHistory.perPage =
          action?.payload?.data?.data?.perPage ?? 10;
        state.importHistory.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getMeeshoImportHistory.rejected, (state, action) => {
        state.importHistory.loading = false;
        state.importHistory.list = [];
        state.importHistory.perPage = 10;
        state.importHistory.total = 0;
      })

      // Dashboard Data
      .addCase(getMeeshoDashboard.pending, (state) => {
        state.dashboard.loading = true;
      })
      .addCase(getMeeshoDashboard.fulfilled, (state, action) => {
        state.dashboard.loading = false;
        state.dashboard.data =
          action?.payload?.data?.data?.dashboardData ?? null;
      })
      .addCase(getMeeshoDashboard.rejected, (state, action) => {
        state.dashboard.loading = false;
        state.dashboard.data = null;
      });
  },
});

export const { clearSelectedOrder, setSelectedOrder } = meeshoSlice.actions;
export default meeshoSlice.reducer;
